module.exports = __webpack_public_path__ + "static/img/pvh-logo.b1910221.png";